/**
 * @file: useShowQrcodeSharingMoreActions.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useActionSheet } from '@expo/react-native-action-sheet';
import { RefObject, useCallback } from 'react';
import { View, findNodeHandle } from 'react-native';

export const useShowQrcodeSharingMoreActions = ({
  onViewSubscriptions,
}: {
  onViewSubscriptions: () => void;
}) => {
  const { showActionSheetWithOptions } = useActionSheet();
  return useCallback(
    (options?: { anchor?: RefObject<View> }) => {
      const nodeId = options?.anchor?.current
        ? findNodeHandle(options.anchor.current)
        : undefined;
      showActionSheetWithOptions(
        {
          anchor: nodeId ?? undefined,
          cancelButtonIndex: 1,
          options: ['查看关注记录', '关闭'],
        },
        async buttonIndex => {
          if (buttonIndex === 0) {
            onViewSubscriptions?.();
          }
        },
      );
    },
    [onViewSubscriptions, showActionSheetWithOptions],
  );
};
